<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-dialog
    v-model="timePickerDialog"
    max-width="400px"
  >
    <template #activator="{on,attr}">
      <v-card
        :class="'pa-3 '+cardClass"
        :color="color"
        class="d-flex align-center px-4 overflow-hidden"
        elevation="0"
        v-bind="attr"
        v-on="on"
      >
        <v-icon class="mr-2 mt-1">
          mdi-calendar-sync-outline
        </v-icon>
        <v-spacer />
        <div class="text-truncate">
          {{ realValue | niceLabel }}
        </div>
      </v-card>
    </template>
    <v-card
      class="pa-6"
      color="#f6f6f6"
    >
      <date-range-picker v-model="realValue" />
      <v-btn
        block
        class="mt-2"
        color="amber lighten-4 black--text"
        elevation="0"
        rounded
        x-large
        @click="confirmDate"
      >
        {{ $t('confirm') }}
        <v-icon
          right
        >
          mdi-check
        </v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from '@/views/widget/commonLogic/DateRangePicker.vue'
import { today } from '@/model/utils/DateRepository'

export default {
  name: 'DatePickerInput',
  components: {
    DateRangePicker
  },
  props: {
    color: {},
    value: {},
    cardClass: {}
  },
  data: function () {
    return {

      realValue: [today, today],
      timePickerDialog: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.realValue = val
      }
    }
    // realValue (val, old) {
    //   if (val !== old) {
    //     this.$emit('input', val)
    //   }
    // }
  },
  methods: {
    confirmDate () {
      this.$emit('input', this.realValue)
      this.timePickerDialog = false
    }
  }
}
</script>

<style scoped>

</style>
